import { PatientDisplayUtils } from './PatientDisplay.utils';
import type {
    PatientDetailPatientCardPatient_FragmentFragment,
    PatientScanCardScan_FragmentFragment,
    PatientScanPillContentScan_FragmentFragment,
} from '@orthly/graphql-inline-react';
import { LabsGqlPatientScanPillContentIcon, LabsGqlPatientScanPillContentVariant } from '@orthly/graphql-schema';
import type { FlossColor, IconName } from '@orthly/ui-primitives';
import dayjs from 'dayjs';

interface PatientDetailConfig {
    name: string;
    birthday: string;
    age: string;
    gender: string;
}

export class PatientDetailUtils {
    static getPatientDetailConfig(patient: PatientDetailPatientCardPatient_FragmentFragment): PatientDetailConfig {
        const name = PatientDisplayUtils.getPatientName(patient);
        const age = PatientDisplayUtils.getPatientAge(patient);
        const birthday = PatientDisplayUtils.getPatientBirthday(patient);
        const gender = PatientDisplayUtils.getPatientGender(patient);

        return {
            name,
            birthday,
            age,
            gender,
        };
    }

    static getPatientScanUpdatedAt(scan: PatientScanCardScan_FragmentFragment): string {
        return `Updated ${dayjs(scan.updated_at).format('M/D')}`;
    }

    static getPatientScanPillContentConfig(pillContent: PatientScanPillContentScan_FragmentFragment['pill_content']): {
        icon: IconName;
        backgroundColor: FlossColor;
    } {
        const icon = this.getPatientPillContentIcon(pillContent);
        const backgroundColor = this.getPatientPillContentBackgroundColor(pillContent);

        return {
            icon,
            backgroundColor,
        };
    }

    private static getPatientPillContentIcon(
        pillContent: PatientScanPillContentScan_FragmentFragment['pill_content'],
    ): IconName {
        switch (pillContent.icon) {
            case LabsGqlPatientScanPillContentIcon.Truck:
                return 'TruckIcon';
            case LabsGqlPatientScanPillContentIcon.Check:
                return 'CheckIcon';
            case LabsGqlPatientScanPillContentIcon.Archived:
                return 'ArchiveIcon';
            case LabsGqlPatientScanPillContentIcon.Lab:
                return 'LabIcon';
            case LabsGqlPatientScanPillContentIcon.Warning:
                return 'WarningIcon';
        }
    }

    private static getPatientPillContentBackgroundColor(
        pillContent: PatientScanPillContentScan_FragmentFragment['pill_content'],
    ): FlossColor {
        switch (pillContent.variant) {
            case LabsGqlPatientScanPillContentVariant.Primary:
                return 'BLACK';
            case LabsGqlPatientScanPillContentVariant.Secondary:
                return 'ATTENTION';
            case LabsGqlPatientScanPillContentVariant.Warning:
                return 'WARNING';
            case LabsGqlPatientScanPillContentVariant.Archived:
                return 'GRAY';
        }
    }
}
